import { DEFAULT_AVATAR_URL } from '../../../utils/consts';
import { getRatingColor, truncateToOneDecimal } from '../../../utils/helpers';

import './userAvatar.css';

interface UserAvatarProps {
    imageSrc?: string | null;
    size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
    onClick?: () => void;
    averageRating?: number;
}

const UserAvatar = ({
    imageSrc,
    size = 's',
    onClick,
    averageRating,
}: UserAvatarProps) => {
    const badgeColor = getRatingColor(averageRating);

    return (
        <div className="user-avatar-wrapper">
            <img
                className={`profile-img ${size} ${onClick ? 'clickable' : ''}`}
                src={imageSrc || DEFAULT_AVATAR_URL}
                alt="avatar"
                data-testid="user-avatar"
                onClick={onClick}
            />
            {averageRating ? (
                <div
                    className={`user-level ${size}`}
                    style={{ backgroundColor: badgeColor }}
                >
                    <p>{truncateToOneDecimal(averageRating)}</p>
                </div>
            ) : null}
        </div>
    );
};

export default UserAvatar;
